import {useEffect} from 'react'
import {useSearchParams} from '@github-ui/react-router'
import {useNavigate} from '@github-ui/use-navigate'
import {ISSUES_DASHBOARD_SEARCH_PATH} from '../constants/routes'
import {issuesDashboardSurfaceContentRoute} from './issues-dashboard-surface-content-route'

/**
 * Index-route gate for /issues/dashboard.
 * - /issues/dashboard?q=xxx  → redirects to /issues/dashboard/search?q=xxx
 * - /issues/dashboard        → redirects to the default assigned view
 */
export function IssuesDashboardIndexGate() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const hasQuery = searchParams.has('q')

  useEffect(() => {
    if (hasQuery) {
      navigate({pathname: ISSUES_DASHBOARD_SEARCH_PATH, search: searchParams.toString()}, {replace: true})
      return
    }

    // Default to the "assigned" view
    navigate({pathname: issuesDashboardSurfaceContentRoute.generatePath({mode: 'assigned'})}, {replace: true})
  }, [hasQuery, navigate, searchParams])

  return null
}
